var colorval              = $( ".section--product .product-single__variants option:selected" ).data('option2');
var sizeval               = $( ".section--product .product-single__variants option:selected" ).data('option1');

if ($('.list-radios--size').length) {
  $('.section--product .list-radios--size li[data-variant="'+ colorval +'"]').find('input').prop('checked', true);
  $('.section--product .select-color').val(sizeval);
} else {
  $('.section--product .select-color').val(sizeval);
}


var selectedColorOnLOad   = $('.list-radios--size').find('input[type="radio"]:checked').val();

// filterImages(selectedColorOnLOad);
// filterVariants(selectedColorOnLOad);

$(".section--product .list-radios--size li").each(function() {
  var $item               = $(this);
  var $radio              = $item.find('.radio');
  var itemColor           = $item.data('variant');
  var disabledColors      = $('.product-single__variants option[data-option2="'+itemColor+'"]:not(:disabled)').length;

  if (disabledColors < 1 ) {
    $item.add($radio).addClass('disabled');
    $item.find('input').prop('disabled', true);
  };
});

setDisabledInputs();

//  Change product image slider on collection boards template
$('.section--product .list-radios input[type="radio"]').on('change', function() {
  const $this             = $(this);
  const $selectedOptions  = $this.closest('.list-radios').find('input[type="radio"]:checked');
  const $productSelect    = $this.closest('form').find('.product-select');

  let selector            = '';
  let colorIndex          = '';
  let colorData           = '';

  var sizeval = $( ".product-single__variants option:selected" ).data('option1');
  
  // Reset all size inputs
  $(".list-radios--size li").add($('.list-radios--size li .radio')).removeClass('disabled');
  $('.section--product .select-color option').prop('disabled', false);

  // Set disabled size inputs on color change
  setDisabledInputs();

  var selectedColor       = $('.list-radios--size').find('input[type="radio"]:checked').val();
  var selectedSize;

  $('.select-color option').each(function() {
    if ($(this).prop('disabled') == false) {
      selectedSize = $(this).val();

      $('.section--product .select-color').val($(this).val());

      return false;
    };
  });

  // filterVariants(selectedColor)
  // filterImages(selectedColor)

  $selectedOptions.each(function() {
    const $radio          = $(this);
    const option          = $radio.closest('.form__row').data('option');

    selector += `[data-${option}="${$radio.val()}"]`;
    colorData = '[data-color="'+selectedSize+'"]';
  });

  $productSelect
    .find(`option${selector+colorData}`)
    .prop('selected', true)
    .trigger('change');

});

$('.section--product .select-color').on('change', function() {
  const $this             = $(this);
  const $selectedOptions  = $this.find('option:selected');
  const $productSelect    = $this.closest('form').find('.product-select');

  let selector            = '';
  let colorIndex          = '';
  let colorData           = '';

  var selectedColor       = $('.list-radios--size').find('input[type="radio"]:checked').val();

  $selectedOptions.each(function() {
    const $radio          = $(this);
    const option          = $radio.closest('.form__row').data('option');

    selector += `[data-${option}="${$radio.val()}"]`;
    colorData = '[data-color="'+selectedColor+'"]';
  });

  if ($('.list-radios--size').length) {
    $productSelect
      .find(`option${selector+colorData}`)
      .prop('selected', true)
      .trigger('change');
  } else {
    $productSelect
      .find(`option${selector}`)
      .prop('selected', true)
      .trigger('change');
  }

  var colorval            = $( ".product-single__variants option:selected" ).data('option2');

  $('.section--product .list-radios--size li[data-variant="'+ colorval +'"]').find('input').prop('checked', true);
});

function setDisabledInputs() {
  if ($('.list-radios--size').length) {
    // Disable false size input if product has color variants
    var checkedColor        = $(".list-radios--size input:checked").val();

    $('.select-color option').removeClass('disabled');

    $('.section--product .select-color option').each(function() {
      var $item             = $(this);
      var $radio            = $item;
      var itemColor         = $item.data('variant');
      var disabledColors    = $('.product-single__variants option[data-option1="'+itemColor+'"][data-option2="'+checkedColor+'"]:not(:disabled)').length;
      var optionIndex       = $item.index();

      if ($('.list-radios--size').length) {
        if (disabledColors < 1 ) {
          $item.addClass('disabled');
          $item.prop('disabled', true);
        };
      };
    });

  } else {
    
    // Disable false size input if there is no color variants
    $('.product-single__variants option').each(function() {
      if ($(this).prop('disabled') == true) {
        var disabledIndex = $(this).index();
        $('.select-color option').eq(disabledIndex).prop('disabled', true)
      };
    });
  }
}

function filterImages(variandTitle) {
  $('.product__slider--desktop img').removeClass('hidden');
  
  if ($('.product__slider--desktop img:not([data-variant="'+variandTitle+'"])').length < $('.product__slider--desktop img').length) {
    $('.product__slider--desktop img:not([data-variant="'+variandTitle+'"])').addClass('hidden');
  };
}

function filterVariants(colorVariant) {
  var allcolor = $('#product .product__slider.js-slider .slick-slide.color--' + colorVariant).length;

  if ($('#product .product__slider.js-slider').hasClass('slick-slider')) {
    $('#product .product__slider.js-slider').slick('slickUnfilter');
    $('#product .product__slider.js-slider').slick('slickFilter', '.color--' + colorVariant);
    $('#product .product__slider.js-slider').slick('slickGoTo', 0);
  }
}
